import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-workorder-after-sales4-modal',
  templateUrl: './workorder-after-sales4-modal.component.html',
  styleUrls: ['./workorder-after-sales4-modal.component.scss'],
})
export class WorkorderAfterSales4ModalComponent {
  constructor(
    private dialogRef: MatDialogRef<WorkorderAfterSales4ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  close() {
    this.dialogRef.close();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/user/profile/seats']);
    });
  }
}
